module.exports = __webpack_public_path__ + "img/www.agoda.com.58ff6592.png";